<div #containerRef class="dot-wave-container position-absolute top-0 start-0 w-100 h-100 bg-dark overflow-hidden">
    <canvas #canvas></canvas>
</div>
<div class="top-glow-effect position-absolute"></div>